import AccountIcon from "../../assets/svg/account.svg";
import AddIcon from "../../assets/svg/add.svg";
import BlackClearIcon from "../../assets/svg/blackClear.svg";
import BusinessDashboard from "../../assets/svg/businessintli.svg";
import ClearIcon from "../../assets/svg/clear.svg";
import dashboard_search from "../../assets/svg/dashboard_search.svg";
import DateRangeIcon from "../../assets/svg/dateRange.svg";
import DeveloperDashboard from "../../assets/svg/developerCenter.svg";
import DocumentationIcon from "../../assets/svg/documentation.svg";
import UploadDownloadIcon from "../../assets/svg/downloadFile.svg";
import DropDownIcon from "../../assets/svg/dropDownArrow.svg";
import EditIcon from "../../assets/svg/edit.svg";
import failure_trans from "../../assets/svg/failed_trans.svg";
import FinanceDashboard from "../../assets/svg/financeCenter.svg";
import InvoiceIcon from "../../assets/svg/invoice.svg";
import ApiKeyIcon from "../../assets/svg/key.svg";
import NeokredLogo from "../../assets/svg/NeokredLogo.svg";
import NeokredLogoNew from "../../assets/png/Neokred_Logo.png";
import NeokredTriangle_Icon from "../../assets/svg/neokredTriangle.svg";
import NotificationNav from "../../assets/svg/Notification.svg";
import PaginationIcon from "../../assets/svg/paginationArrow.svg";
import PasswordHider_Icon from "../../assets/svg/passwordhide.svg";
import PasswordView_Icon from "../../assets/svg/passwordvisible.svg";
import RemoveIcon from "../../assets/svg/remove.svg";
import ReportIcon from "../../assets/svg/report.svg";
import ReviewIcon from "../../assets/svg/review.svg";
import success_trans from "../../assets/svg/success_trans.svg";
import TransactionDashboard from "../../assets/svg/transactionCenter.svg";
import UploadIcon from "../../assets/svg/upload.svg";
import ReportCenter_Icon from "../../assets/svg/report_center.svg";
import CustomerCenter_Icon from "../../assets/svg/customer_center.svg";
import EditPen_Svg from "../../assets/svg/edit_pen.svg";
import ReportDownload_Svg from "../../assets/svg/report_download.png";
import BulkFile_Svg from "../../assets/svg/bulk_file.svg";
import BulkFileUpload_Svg from "../../assets/svg/bulk_upload_file.svg";
import Bank_Svg from "../../assets/svg/bank.svg";
import Upi_Svg from "../../assets/svg/upi.svg";
import Edit_Pencil from "../../assets/svg/edit_pencil.svg";
import CustomDate from "../../assets/svg/date_picker.svg";
import PayOutSvg from "../../assets/svg/pay_out.svg";
import CustomerManagementSvg from "../../assets/svg/customermanagement.svg";
import BeneficiaryManagmentSvg from "../../assets/svg/beneficiaryManagment.svg";
import BeneficiaryEditSvg from "../../assets/svg/beneficiaryEdit.svg";
import EditBeneficiarySvg from "../../assets/svg/editbeneficiary.svg";
import Scroll1Svg from "../../assets/svg/scroll1.svg";
import Scroll2Svg from "../../assets/svg/scroll2.svg";
import neorkedlogo from "../../assets/png/neokredlogo1.png";
import { ReactComponent as backcon } from "../../assets/svg/back.svg";
import { ReactComponent as clearicon } from "../../assets/svg/clear1.svg";

export const Neokred = NeokredLogo;
export const NeokredNewLogo = NeokredLogoNew;
export const TransactionCenter = TransactionDashboard;
export const FinanceCenter = FinanceDashboard;
export const DeveloperCenter = DeveloperDashboard;
export const ReportCenter = ReportCenter_Icon;
export const CustomerCenter = CustomerCenter_Icon;
export const BusinessCenter = BusinessDashboard;
export const Notification = NotificationNav;
export const Dropdown = DropDownIcon;
export const DateRange = DateRangeIcon;
export const Invoice = InvoiceIcon;
export const Report = ReportIcon;
export const Documenatation = DocumentationIcon;
export const ApiKey = ApiKeyIcon;
export const Account = AccountIcon;
export const Add = AddIcon;
export const Upload = UploadIcon;
export const UploadDownload = UploadDownloadIcon;
export const Remove = RemoveIcon;
export const Review = ReviewIcon;
export const Clear = ClearIcon;
export const BlackClear = BlackClearIcon;
export const Edit = EditIcon;
export const PaginationArrow = PaginationIcon;
export const NeokredTriangle = NeokredTriangle_Icon;
export const PasswordHide = PasswordHider_Icon;
export const PasswordView = PasswordView_Icon;
export const FailedTransaction = failure_trans;
export const SuccessTransaction = success_trans;
export const DashboardSearchIcon = dashboard_search;
export const EditPen = EditPen_Svg;
export const ReportDownload = ReportDownload_Svg;
export const BulkFile = BulkFile_Svg;
export const BulkFileUpload = BulkFileUpload_Svg;
export const BankIcon = Bank_Svg;
export const UpiIcon = Upi_Svg;
export const EditPencil = Edit_Pencil;
export const CustomDate_Svg = CustomDate;
export const PayOut = PayOutSvg;
export const CustomerManagement = CustomerManagementSvg;
export const BeneficiaryManagment = BeneficiaryManagmentSvg;
export const BeneficiaryEdit = BeneficiaryEditSvg;
export const EditBeneficiary_Svg = EditBeneficiarySvg;
export const Scroll1_Svg = Scroll1Svg;
export const Scroll2_Svg = Scroll2Svg;

export const NeokredLogo1 = neorkedlogo;
export const BackSvg = backcon;
export const ClearSvg = clearicon;
